var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVendor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9938 3.89724L14.8519 0.397437C14.8121 0.276705 14.7348 0.172576 14.6317 0.100954C14.5286 0.0293322 14.4054 -0.00584589 14.2809 0.000793261H1.71913C1.59462 -0.00584589 1.4714 0.0293322 1.3683 0.100954C1.2652 0.172576 1.18787 0.276705 1.14815 0.397437L0.00616973 3.89724C-0.00205658 3.95917 -0.00205658 4.02196 0.00616973 4.0839V7.5837C0.00616973 7.7384 0.0663272 7.88676 0.173408 7.99615C0.280489 8.10554 0.425722 8.167 0.577158 8.167H1.14815V14H2.29012V8.167H5.71605V14H14.8519V8.167H15.4228C15.5743 8.167 15.7195 8.10554 15.8266 7.99615C15.9337 7.88676 15.9938 7.7384 15.9938 7.5837V4.0839C16.0021 4.02196 16.0021 3.95917 15.9938 3.89724ZM13.7099 12.8334H6.85802V8.167H13.7099V12.8334ZM14.8519 7.0004H12.5679V4.6672H11.4259V7.0004H8.57099V4.6672H7.42901V7.0004H4.57407V4.6672H3.4321V7.0004H1.14815V4.17722L2.13024 1.16739H13.8698L14.8519 4.17722V7.0004Z",
    fill: "#171717"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendor);
export default __webpack_public_path__ + "static/media/vendor.e619a8a1.svg";
export { ForwardRef as ReactComponent };